const RESOURCE_NAME = '/insurance-reports';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
    removed(id, params) {
        return axios.post(`${RESOURCE_NAME}/${id}/removed`, {}, {params});
    },
    restore(id, params) {
        return axios.post(`${RESOURCE_NAME}/${id}/restore`, {}, {params});
    },

    export(id, format, params) {
        return axios.get(`${RESOURCE_NAME}/${id}/export/${format}`, {params});
    },
});